<template>
  <b-card-code class="grafica-paises">
    <b-row>
      <b-col cols="6">
        <div id="chart">
          <apexchart
            type="bar"
            height="350"
            :options="chartVentasPorPais"
            :series="seriesVentasPorPais"
          ></apexchart>
        </div>
      </b-col>
      <b-col cols="6">
        <div id="chart">
          <apexchart
            type="bar"
            height="350"
            :options="chartVentasPorCategorias"
            :series="seriesVentasPorCategorias"
          ></apexchart>
        </div>
      </b-col>
    </b-row>
  </b-card-code>
</template>

<script>
/*import VueApexCharts from 'vue-apexcharts'*/
import {
  BTable,
  BFormCheckbox,
  BFormInput,
  BFormGroup,
  BModal,
  BCardText,
  BCardBody,
  BCard,
  BRow,
  BCol,
  BSpinner,
  BButton,
  BFormRadio,
} from "bootstrap-vue";
import BCardCode from "@core/components/b-card-code";
import flatPickr from "vue-flatpickr-component";
import VueSlider from "vue-slider-component";

export default {
  components: {
    BCardCode,
    BFormCheckbox,
    BTable,
    BFormInput,
    BFormGroup,
    BCardText,
    BCardBody,
    BCard,
    BRow,
    BCol,
    BSpinner,
    BButton,
    BFormRadio,
    flatPickr,
    VueSlider,
  },
  data() {
    return {
      coloresGrafica: [
        "#eb6170",
        "#2586ed",
        "#8772d1",
        "#e0914c",
        "#6399c1",
        "#f9fa66",
        "#e0684c",
        "#146799",
        "#ecbd49",
        "#eb6170",
        "#2586ed",
        "#8772d1",
        "#e0914c",
        "#6399c1",
        "#f9fa66",
        "#e0684c",
        "#146799",
        "#ecbd49",
        "#eb6170",
        "#2586ed",
        "#8772d1",
        "#e0914c",
        "#6399c1",
        "#f9fa66",
        "#e0684c",
        "#146799",
        "#ecbd49",
        "#eb6170",
        "#2586ed",
        "#8772d1",
        "#e0914c",
        "#6399c1",
        "#f9fa66",
        "#e0684c",
        "#146799",
        "#ecbd49",
      ],
      seriesVentasPorPais: [{ name: "", data: [0, 0] }],
      chartVentasPorPais: {
        chart: {
          type: "bar",
          height: 500,
          stacked: true,
          //stackType: "100%"

        },
        plotOptions: {
            bar: {
                horizontal: true,
                dataLabels: {
                    total: {
                        enabled: true,
                        offsetX: 0,
                        style: {
                            fontSize: '13px',
                            fontWeight: 900
                        }
                    }
                }
            },
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ["#ffffff"], 
            fontWeight: "bold",
          },
        },
        legend: {
          show: true,
        },
        stroke: {
          width: 1,
          colors: ["#fff"],
        },
        title: {
          text: "Ventas por País",
          align: "middle",
        },     
      },
      chartVentasPorCategorias: {
        chart: {
          type: "bar",
          height: 500,
          stacked: true,
          stackType: "100%"

        },
        plotOptions: {
            bar: {
                horizontal: true,
                dataLabels: {
                    total: {
                        enabled: true,
                        offsetX: 0,
                        style: {
                            fontSize: '13px',
                            fontWeight: 900
                        }
                    }
                }
            },
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ["#ffffff"], 
            fontWeight: "bold",
          },
        },
        legend: {
          show: true,
        },
        stroke: {
          width: 1,
          colors: ["#fff"],
        },
        title: {
          text: "Ventas por País Categorías %",
          align: "middle",
        },     
      },
      seriesVentasPorCategorias: [{ name: "", data: [0, 0] }],
      orders: [],
      tipoDatos: "Libras",
    };
  },
  props: ["items","tipoDatosCalcular"],
  methods: {
    calcularGraficaStacked() {
  const datos = {};
  const paisesSet = new Set();
  const tiposSet = new Set(["Sleeves", "Accessories", "Bags", "Wallets"]);

  let total = 0;
  const totalPorPais = {};

  this.orders.forEach((order) => {
    const country = order.shipping_address?.country || "Desconocido";
    if (country === "Desconocido") return;

    paisesSet.add(country);
    if (!totalPorPais[country]) totalPorPais[country] = 0;

    order.line_items.forEach((item) => {
      const tipo = item.product_type?.trim() || "Desconocido";
      if (tipo === "Desconocido") return;

      tiposSet.add(tipo);

      if (!datos[tipo]) datos[tipo] = {};
      if (!datos[tipo][country]) datos[tipo][country] = 0;

      const cantidad = Number(item.quantity) || 0;
      const precio = parseFloat(item.price) || 0;
      const importe = precio * cantidad;

      if (this.tipoDatos === "Libras") {
        datos[tipo][country] += importe;
        totalPorPais[country] += importe;
        total += importe;
      } else {
        datos[tipo][country] += cantidad;
        totalPorPais[country] += cantidad;
        total += cantidad;
      }
    });
  });

  const paisesOrdenados = Array.from(paisesSet).sort((a, b) => totalPorPais[b] - totalPorPais[a]);
  const top10Paises = paisesOrdenados.slice(0, 10);
  const maxTotal = Math.max(0, ...top10Paises.map((pais) => totalPorPais[pais]));
  const paisesConTotal = top10Paises.map(pais =>
    this.tipoDatos === "Libras"
      ? `${pais} (£${totalPorPais[pais].toFixed(0)})`
      : `${pais} (${totalPorPais[pais]})`
  );

  const tipos = Array.from(tiposSet);

  const series = tipos.map((tipo) => {
    const porPais = datos[tipo] || {}; // tipos pre-sembrados pueden no tener ventas en el rango
    const data = top10Paises.map((pais) => {
      return this.tipoDatos === "Libras"
        ? parseFloat((porPais[pais] || 0).toFixed(0))
        : porPais[pais] || 0;
    });

    return {
      name: tipo,
      data: data,
    };
  });

  const unidad = this.tipoDatos === "Libras" ? "£" : "ventas";
  const titulo = this.tipoDatos === "Libras"
    ? `Ventas por País (£${total.toFixed(0)})`
    : `Ventas por País (${total} ventas)`;

  const opcionesBase = {
    chart: {
      type: "bar",
      height: 500,
      stacked: true,
      events: {
        dataPointSelection: (e, ctx, { seriesIndex, dataPointIndex }) => {
          this.$emit("filtrar", { pais: top10Paises[dataPointIndex], tipo: tipos[seriesIndex] });
        },
      },
    },
    plotOptions: {
      bar: {
        horizontal: true,
        dataLabels: {
          total: {
            enabled: true,
            offsetX: 0,
            style: {
              fontSize: "13px",
              fontWeight: 900,
            },
          },
        },
      },
    },
    stroke: {
      width: 2,
      colors: ["#fff"],
    },
    xaxis: {
      categories: paisesConTotal,
    },
    yaxis: {
      title: {
        text: undefined,
      },
    },
    tooltip: {
      y: {
        formatter: (val) =>
          this.tipoDatos === "Libras" ? `£${val.toFixed(0)}` : `${val} unidades`,
      },
    },
    fill: {
      opacity: 1,
    },
    legend: {
      position: "top",
      horizontalAlign: "center",
      offsetX: 40,
    },
    dataLabels: {
      enabled: true,
      // Ocultar etiquetas de segmentos pequeños (< 7% del país mayor) para que no se solapen
      formatter: (val) => (val < maxTotal * 0.07 ? "" : val),
      style: {
        colors: ["#ffffff"],
        fontWeight: "bold",
      },
    },
    title: {
      text: titulo,
      align: "middle",
    },
    //colors: this.coloresGrafica,
  };

  this.chartVentasPorPais = opcionesBase;
  this.seriesVentasPorPais = series;

  // Gráfica de al lado: apilada al 100%, etiquetas en % de cada país (ocultas si < 7%)
  this.chartVentasPorCategorias = {
    ...opcionesBase,
    chart: { ...opcionesBase.chart, stackType: "100%" },
    title: { ...opcionesBase.title, text: "Reparto por categoría (%)" },
    dataLabels: {
      ...opcionesBase.dataLabels,
      style: { colors: tipos.map(() => "#ffffff"), fontWeight: "bold" },
      // con stackType 100% apex ya pasa el valor en porcentaje
      formatter: (val) => (val < 7 ? "" : `${val.toFixed(0)}%`),
    },
  };
  this.seriesVentasPorCategorias = series;
}

  },
  watch: {
    items() {
      this.orders = this.items;
      this.calcularGraficaStacked();
    },
    tipoDatosCalcular() {
      this.tipoDatos = this.tipoDatosCalcular;
      this.calcularGraficaStacked();
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/vue-slider.scss";

// Vuexy pinta las etiquetas de ApexCharts con el color del body; aquí van sobre barras de color
.grafica-paises .apexcharts-datalabels .apexcharts-datalabel {
  fill: #fff !important;
}
.grafica-paises .apexcharts-bar-area { cursor: pointer; }
</style>